const ACTIVITY_TYPES = {
  communication: "COMMUNICATION",
  production: "PRODUCTION",
  review: "REVIEW",
  planning: "PLANNING",
};

export default ACTIVITY_TYPES;
